import { ref } from "vue";

const breadcrumb = ref({
  home: null,
  items: [],
});

export function useBreadcrumb() {
  function setBreadcrumb({ home, items }) {
    breadcrumb.value = { home, items };
  }
  function clearBreadcrumb() {
    breadcrumb.value = { home: null, items: [] };
  }
  return {
    breadcrumb,
    setBreadcrumb,
    clearBreadcrumb,
  };
}
